import useProjectTypesState from 'screens/Admin/ProjectTypes/hooks/useProjectTypesState'
import { IProjectType } from 'screens/Admin/ProjectTypes/projectTypes.types'
import Dropdown from 'shared/Inputs/Dropdown'

interface IProps {
  value: string | null
  options: IProjectType[]
  name: string
  onChange: (val: string, name: string) => void
}

const FaqProjectTypeSelect = (props: IProps) => {
  const { projectTypesMap } = useProjectTypesState()

  const handleSelect = (val: IProjectType | null) => {
    props.onChange(val?.id, props.name)
  }

  const selected = projectTypesMap[props.value]

  return (
    <Dropdown
      options={props.options}
      selectedOption={selected}
      title='Тип проекта'
      onSelect={handleSelect}
      getOptionKey={(o) => o?.id}
      getOptionLabel={(o) => o?.name}
    />
  )
}

export default FaqProjectTypeSelect
